import Close from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";

const useStyles = makeStyles(() => ({
  container: {
    padding: "16px 24px",
  },
}));
const ActionDialog = (props) => {
  const classes = useStyles();
  const { children, setOpen, open, onSubmit, label, buttonText, noClose } =
    props;
  const handleClose = () => {
    if (!noClose) {
      setOpen(false);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "24px",
        },
      }}
    >
      <Paper className={classes.container}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            container
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Grid item xs>
              <Typography variant="subtitle1">{label}</Typography>
            </Grid>
            {!noClose && (
              <Grid item xs container justifyContent={"end"}>
                <IconButton onClick={handleClose}>
                  <Close />
                </IconButton>
              </Grid>
            )}
          </Grid>
          <Grid item xs={12}>
            {children}
          </Grid>
          <Grid item xs={12}>
            {onSubmit && (
              <Button variant="contained" fullWidth onClick={onSubmit}>
                {buttonText}
              </Button>
            )}
          </Grid>
        </Grid>
      </Paper>
    </Dialog>
  );
};

export default ActionDialog;
